import axios from 'axios';

export default {
  baseURL: process.env.BASE_URL + 'api/users',

  getUserProfile() {
    return axios.get('profile',
      { 
        baseURL: this.baseURL
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  // setUserProfile(settings) {
  //   return axios.put('profile', settings,
  //     { 
  //       baseURL: this.baseURL,
  //     })
  //     .then(function (response) {
  //       return response;
  //     });
  // }

  getUserOfPermissionList(permission) {
    return axios.get('users-of-permission',
      { 
        baseURL: this.baseURL,
        params: {
          "permission": permission,
        },
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },


  getUserList() {
    return axios.get('users',
      { 
        baseURL: this.baseURL,
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },
  getPermissionList() {
    return axios.get('permissions',
      { 
        baseURL: this.baseURL,
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },
  getPermissionsOfUser(userId) {
    return axios.get('permissions-of-user',
      { 
        baseURL: this.baseURL,
        params: {
          "userId": userId,
        },
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },
  setPermissionOfUser(userAndPermission) {
    return axios.post(
      'set-permission-of-user', 
      userAndPermission,
      {
        baseURL: this.baseURL
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return Promise.reject(error);
    });
  },
}